import AddCouponPage from './AddCouponPage';
import './AddCouponPage.css';

export default AddCouponPage;



// WEBPACK FOOTER //
// ./src/pages/Account/containers/AddCouponPage/index.js